(() => {
  const box = document.querySelector('[data-delivery-cart]');
  if (!box) return;
  const form = box.closest('form');
  const cents = Number(box.dataset.subtotal);
  const free = cents >= 800000;
  const method = box.querySelector('#delivery-method');
  const pickup = box.querySelector('#delivery-pickup');
  const area = box.querySelector('#delivery-area');
  const town = box.querySelector('#delivery-town');
  const agent = box.querySelector('#delivery-agent');
  const metro = box.querySelector('#delivery-metro');
  const address = box.querySelector('#delivery-address');
  const checkout = box.querySelector('[data-delivery-checkout]');
  const email = box.querySelector('#delivery-email');
  const phone = box.querySelector('#delivery-phone');
  const recipient = box.querySelector('#delivery-recipient');
  const error = box.querySelector('[data-delivery-error]');
  const fields = Object.fromEntries([...box.querySelectorAll('[data-delivery-field]')].map(el => [el.dataset.deliveryField, el]));
  const nairobi = {"Adams Arcade":200,"Baba Dogo":400,"Buruburu":400,"CBD":200,"City Park":250,"Community":200,"Donholm":350,"Eastlands":350,"Eastleigh":350,"Embakasi":400,"Garden City":400,"Gigiri":350,"Highridge":250,"Hurlingham":200,"Imara Daima":350,"Industrial Area":350,"JKIA":500,"Jamhuri":200,"Kabarnet Road":200,"Kahawa West":450,"Karen":400,"Kariobangi":400,"Kasarani":400,"Kayole":350,"Kileleshwa":200,"Kilimani":200,"Komarock":350,"Kyuna":300,"Langata":300,"Lavington":150,"Loresho":350,"Madaraka":300,"Mountain View":400,"Muthaiga":400,"Nairobi West":250,"Naivasha Road":200,"Ndumbuini":350,"Ngara":300,"Ngumo":250,"Nyari":350,"Pangani":300,"Parklands":250,"Race Course":300,"Riara Road":200,"Ridgeways":400,"Riverside":200,"Rosslyn":400,"Roysambu":400,"Ruai":550,"Runda":400,"Safari Park":400,"South B":300,"South C":300,"State House Road":200,"Survey":400,"Thome":400,"Two Rivers":400,"Umoja":400,"Upper Hill":200,"Utawala":600,"Uthiru":400,"Valley Arcade":150,"Village Market":400,"Wanyee Road":200,"Westlands":200,"Woodley":200};
  const outside = {"Athi River":600,"Banana Hill":550,"Busia":400,"Edenville":400,"Eldoret":450,"Embu":400,"Gachie":400,"Juja":600,"Kahawa Sukari":500,"Kajiado":400,"Kakamega":450,"Kamiti":450,"Kapsabet":400,"Kerarapon":500,"Kiambu":400,"Kikuyu":450,"Kinoo":350,"Kisii":450,"Kisumu":450,"Kitale":450,"Kitengela":800,"Limuru":800,"Lodwar":450,"Lower Kabete":350,"Machakos":350,"Malindi":600,"Maua":400,"Meru":400,"Mombasa":500,"Muchatha":450,"Muranga":350,"Naivasha":400,"Nakuru":400,"Nanyuki":500,"Narok":350,"Narumoru":400,"Ngong Town":550,"Nyahururu":400,"Nyeri":350,"Rongai":450,"Ruaka":400,"Ruiru":500,"Siaya":450,"Syokimau":600,"Tatu City":600,"Thika":350,"Thindigua":400,"Tigoni":600,"Ukunda":600,"Wangige":400};
  const money = value => 'KSh ' + value.toLocaleString('en-KE');
  const match = (value, list) => Object.keys(list).find(key => key.toLocaleLowerCase() === value.trim().toLocaleLowerCase());
  function fill(list, target) {
    const datalist = box.querySelector(target);
    datalist.replaceChildren(...Object.keys(list).sort().map(name => {
      const option = document.createElement('option'); option.value = name; return option;
    }));
  }
  fill(nairobi, '#delivery-areas'); fill(outside, '#delivery-towns');
  function update() {
    const selected = method.value;
    const local = selected === 'Pick Up Mtaani';
    const mtaaniAgent = local && pickup.value === 'Local Mtaani agent';
    const superMetro = selected === 'Super Metro';
    const door = selected === 'Nairobi door delivery';
    const upcountry = selected === 'Outside Nairobi';
    const visible = { pickup: local, agent: mtaaniAgent, metro: superMetro, area: door, town: upcountry, address: door || upcountry, recipient: true };
    for (const [key, element] of Object.entries(fields)) {
      element.hidden = !visible[key];
      element.querySelectorAll('input,select').forEach(input => {
        input.disabled = !visible[key];
        input.required = Boolean(visible[key]);
        if (!visible[key]) input.value = '';
      });
    }
    let price;
    let valid = false;
    if (local) {
      price = { 'Local Mtaani agent': 350, CBD: 250, 'Lavington Mall': 150 }[pickup.value];
      valid = price !== undefined && (!mtaaniAgent || agent.value.trim().length > 2);
    } else if (superMetro) {
      price = 350; valid = metro.value.trim().length > 3;
    } else if (door) {
      const key = match(area.value, nairobi); price = key && nairobi[key];
      valid = price !== undefined && address.value.trim().length > 3;
    } else if (upcountry) {
      const key = match(town.value, outside); price = key && outside[key];
      valid = price !== undefined && address.value.trim().length > 3;
    }
    const estimate = valid ? (free ? 0 : price) : null;
    box.querySelector('[data-delivery-price]').textContent = estimate === null ? '—' : money(estimate);
    box.querySelector('[data-delivery-total]').textContent = estimate === null ? '—' : money(cents / 100 + estimate);
    box.querySelector('[data-delivery-message]').textContent = valid ? (free ? 'Your order qualifies for free delivery.' : 'Estimated delivery to your selection: ' + money(price) + '.') : 'Select a listed location and complete the delivery details.';
    checkout.disabled = !valid || !email.validity.valid || !phone.value.trim() || recipient.value.trim().split(/\s+/).length < 2;
  }
  box.addEventListener('input', update);
  box.addEventListener('change', update);
  checkout.addEventListener('click', async () => {
    if (checkout.disabled || !email.reportValidity() || !phone.reportValidity() || !recipient.reportValidity()) return;
    error.hidden = true;
    checkout.disabled = true;
    checkout.textContent = 'Preparing payment…';
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Could not read your cart. Please try again.');
      const cart = await response.json();
      const payload = {
        items: cart.items.map(item => ({ variantId: item.variant_id, quantity: item.quantity, properties: item.properties || {} })),
        delivery: { method: method.value, pickup: pickup.value, agent: agent.value.trim(), metro: metro.value.trim(), area: area.value.trim(), town: town.value.trim(), address: address.value.trim(), recipient: recipient.value.trim() },
        contact: { email: email.value.trim(), phone: phone.value.trim() }
      };
      const result = await fetch('/apps/shea-delivery/checkout', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      const data = await result.json();
      if (!result.ok || !data.checkoutUrl) throw new Error(data.error || 'We could not prepare payment. Please try again.');
      window.location.assign(data.checkoutUrl);
    } catch (cause) {
      error.textContent = cause.message || 'Payment could not be prepared. Please try again.';
      error.hidden = false;
      checkout.textContent = 'Continue to payment';
      update();
    }
  });
  update();
})();
